var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Callout = require('../../components/callout.jsx');

var PasswordReset = createReactClass({
    mixins: [PureRenderMixin],

    componentDidMount: function() {
		$('#show-password').click(function () {
			if ($('#password').attr('type') === 'password') {
				$('#password').attr('type', 'text');
			} else {
				$('#password').attr('type', 'password');
			}
		});
	},

    componentWillUnmount: function(){
        this.props.clearError();
    },

    handlePasswordReset: function(event) {
        event.preventDefault();
        this.props.resetPassword(this.props.params.token, this.refs.password.value, this.refs.rePassword.value);
    },

    handlePasswordResetTracking: function(event){
        var target = event.target;
        var label = target.innerText;
        var action = 'Click';
        this.props.recordPasswordResetClick(action, label);
    },

    render: function () {
        var error = this.props.password.error;
        var success = this.props.password.data;

        return (
            <div className="content">
                <Helmet title='Enter a New Password' />
                <div className="row">
                    <div className="x-large-6 large-6 medium-10 x-large-offset-3 large-offset-3 medium-offset-1 small-12 column end">
                        {Object.keys(error).length !== 0 &&
                            <Callout type="alert" message={error.message ? error.message : error} handleClose={this.props.clearError} />
                        }
                        {Object.keys(success).length !== 0 &&
                            <Callout type="success" message={success} handleClose={this.props.clearError} />
                        }
                        <div className="special-form-box-wrapper">
                            <div className="password-reset-set-box special-form-box">
                                <div className="header">
	                                <h1>Enter a New Password</h1>
	                            </div>
                                <div className="form">
                                    <form onSubmit={this.handlePasswordReset} noValidate autoComplete="off">
                                        <div className="input-field-wrapper">
                                            <div className="input-field">
    	                                        <label className="heading" htmlFor="password">New Password</label>
    	                                        <input type="password" name="password" id="password" ref="password" required />
    	                                    </div>
                                            <div className="input-field">
                                                <label className="heading" htmlFor="rePassword">Re-enter Password</label>
                                                <input type="password" name="rePassword" id="rePassword" ref="rePassword" required />
                                            </div>
                                        </div>
                                        <button className="button secondary" type="submit" onClick={this.handlePasswordResetTracking}>Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = PasswordReset;



// WEBPACK FOOTER //
// ./src/common/routes/password-reset/components/password-reset.jsx